// extracted by mini-css-extract-plugin
module.exports = {"mid":"Skills_mid__3zeVD","color":"Skills_color__1lPkA","flex":"Skills_flex__2oU_z","size":"Skills_size__2-X6z"};